import script from "./QRoundButton.vue?vue&type=script&setup=true&lang=js"
export * from "./QRoundButton.vue?vue&type=script&setup=true&lang=js"

import "./QRoundButton.vue?vue&type=style&index=0&id=f01f4fc6&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f01f4fc6"]])

export default __exports__